import React, { useState, useMemo } from "react";
import ReactSelect from "react-select";
import { CloseIcon, InfoIcon } from "../../commonUI/Icons/SvgIcon";

const SendPushNotification = ({ view, sendPushNotification, onClose }) => {
  const [formData, setFormData] = useState({
    userType: "clients",
    category: "",
    city: "",
    title: "",
    message: "",
    deeplink: "homescreen",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectChange = (selectedOption, { name }) => {
    setFormData((prev) => ({
      ...prev,
      [name]: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Sending push notification:", formData);
    // Add your submission logic here
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  // Custom styles for ReactSelect to match the design
  const selectStyles = useMemo(
    () => ({
      control: (provided) => ({
        ...provided,
        minHeight: "40px",
        height: "40px",
        minWidth: "100%",
        width: "100%",
        padding: "0",
        boxShadow: "none",
        border: "1px solid #ccc",
        borderRadius: "4px",
        "&:hover": {
          borderColor: "#999",
        },
        "&:focus-within": {
          borderColor: "#000000",
          boxShadow: "0 0 0 2px #FFFFFF, 0 0 0 4px #000000",
          outline: "none",
        },
      }),
      valueContainer: (provided) => ({
        ...provided,
        height: "40px",
        padding: "0 12px",
        display: "flex",
        alignItems: "center",
      }),
      input: (provided) => ({
        ...provided,
        margin: "0",
        padding: "0",
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        height: "40px",
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor:
          state?.data?.isChild === false
            ? "#f1f5f9"
            : state?.isSelected
            ? "#f3f4f6"
            : state?.isFocused
            ? "#f8f9fa"
            : null,
        color:
          state?.data?.isChild === false
            ? "#64748b"
            : state?.isSelected
            ? "#000"
            : "#333",
        paddingLeft: state?.data?.isChild ? "30px" : "12px",
        fontWeight:
          state?.data?.isChild === false
            ? "600"
            : state?.data?.isChild
            ? "normal"
            : "500",
        cursor: state?.data?.isChild === false ? "default" : "pointer",
        "&:hover": {
          backgroundColor:
            state?.data?.isChild === false
              ? "#f1f5f9"
              : state?.isSelected
              ? "#f3f4f6"
              : "#f8f9fa",
        },
      }),
      indicatorSeparator: (provided) => ({
        ...provided,
        display: "none",
      }),
      placeholder: (provided) => ({
        ...provided,
        color: "#999",
      }),
    }),
    []
  );

  const userTypeOptions = [
    { value: "clients", label: "Clients 12,453" },
    { value: "drivers", label: "Drivers 8,721" },
    { value: "all", label: "All Users 21,174" },
  ];

  const categoryOptions = [
    { value: "general", label: "General" },
    { value: "promotion", label: "Promotion" },
    { value: "update", label: "Update" },
    { value: "reminder", label: "Reminder" },
    { value: "alert", label: "Alert" },
  ];

  const deeplinkOptions = [
    { value: "homescreen", label: "Homescreen", isChild: false },
    { value: "homescreen", label: "Homescreen", isChild: true },

    { value: "book", label: "Book", isChild: false },
    { value: "book", label: "Book", isChild: true },

    { label: "Booking", isChild: false },
    { value: "bookings", label: "Bookings", isChild: true },

    { label: "Messages", isChild: false },
    { value: "messages", label: "Messages", isChild: true },
    { value: "account", label: "Account", isChild: false },
    { value: "account-account", label: "Account", isChild: true },
    { value: "account-profile", label: "Edit Profile", isChild: true },
    { value: "account-invoices", label: "Invoices", isChild: true },
    { value: "account-settings", label: "Settings", isChild: true },
    {
      value: "account-contact-support",
      label: "Contact Support",
      isChild: true,
    },
  ];

  const selectedUserTypeOption = userTypeOptions.find(
    (option) => option.value === formData.userType
  );
  const selectedCategoryOption = categoryOptions.find(
    (option) => option.value === formData.category
  );

  const selectedDeeplinkOption = deeplinkOptions.find(
    (option) => option.value === formData.deeplink
  );

  return (
    <div className="right-modal push-notification-modal">
      {/* Modal Header */}
      <div className="modal-header">
        <div className="modal-title">
          <h2>Send Push Notification</h2>
          <button
            className="modal-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </div>
      </div>
      {/* Modal Body */}
      <div className="modal-body">
        <form onSubmit={handleSubmit}>
          {/* Choose Audience Section */}
          <div className="form-section mb-24">
            <h3 className="text-lg font-medium">Choose Audience</h3>

            <div className="form-group">
              <label htmlFor="userType" className="form-label">
                User Type
              </label>
              <ReactSelect
                id="userType"
                name="userType"
                classNamePrefix="custom-select"
                placeholder="Select user type"
                options={userTypeOptions}
                value={selectedUserTypeOption}
                onChange={handleSelectChange}
                className="react-select-container"
                styles={selectStyles}
                isSearchable={false}
              />
            </div>

            <div className="form-group">
              <label htmlFor="category" className="form-label">
                Category
              </label>
              <ReactSelect
                id="category"
                name="category"
                classNamePrefix="custom-select"
                placeholder="Select category"
                options={categoryOptions}
                value={selectedCategoryOption}
                onChange={handleSelectChange}
                className="react-select-container"
                styles={selectStyles}
                isSearchable={false}
              />
            </div>
          </div>
          <hr className="mb-24" />

          {/* Compose Message Section */}
          <div className="form-section">
            <h3 className="text-lg font-medium">Compose Message</h3>

            <div className="form-group">
              <label htmlFor="title" className="form-label">
                Title
              </label>
              <input
                type="text"
                id="title"
                name="title"
                className="form-control"
                placeholder="Enter notification title"
                value={formData.title}
                onChange={handleInputChange}
                maxLength={65}
                required
              />
              <div className="character-count">
                <span className="platform-note">Only available on Android</span>
                <span className="count">{formData.title.length}/65</span>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="message" className="form-label">
                Message
              </label>
              <textarea
                id="message"
                name="message"
                className="form-control d-block"
                placeholder="Enter your message here..."
                value={formData.message}
                onChange={handleInputChange}
                rows={4}
                maxLength={178}
                required
              />
              <div className="character-count">
                <span className="text-sm">Up to 178 characters</span>
                <span className="count">{formData.message.length}/178</span>
              </div>
            </div>

            <div className="tags-info">
              <div className="info-icon">
                <InfoIcon />
              </div>
              <div className="tags-content">
                <p className="text-sm">
                  Tags you can use in your notification:
                </p>
                <span className="text-sm">{"{{first_name}}"}</span>,{" "}
                <span className="text-sm">{"{{last_name}}"}</span>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="deeplink" className="form-label">
                Deeplink to screen
              </label>
              <ReactSelect
                id="deeplink"
                name="deeplink"
                classNamePrefix="custom-select"
                placeholder="Select deeplink"
                options={deeplinkOptions}
                value={selectedDeeplinkOption}
                onChange={handleSelectChange}
                className="react-select-container"
                styles={selectStyles}
                isSearchable={false}
                isOptionDisabled={(option) => option.isChild === false}
                menuPlacement="auto"
              />
            </div>
          </div>
        </form>
      </div>{" "}
      <div className="modal-footer">
        <div className="d-flex align-items-center g-12">
          <button className="btn btn-primary">Send Notification</button>
          <button className="btn btn-outline-primary" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendPushNotification;
